import { Answer, Position, Column, ColumnName ,StatusErrorMap} from "../types/types";
import { Dispatch, SetStateAction } from "react";


export type EvaluateAnswersResult = {
  status: StatusErrorMap;
  hasEmpty: boolean;
  hasErrors: boolean;
  isSuccess: boolean;
};

//пропсы для функции создания доски в режиме orbital
export const lightCorrectRooms = (
  status: StatusErrorMap,
  setUIcolumns: Dispatch<SetStateAction<Column[]>>,
) => {
  setUIcolumns((prev) =>
    prev.map((col) => ({
      ...col,
      rooms: col.rooms.map((room) => ({
        ...room,
        lightOn:
          room.characterId !== null && status[room.characterId] === "true",
      })),
    })),
  );
};

// проверка ответов
export const evaluateAnswers = (
  answers: Answer[],
  correctPositions: Answer[],
): EvaluateAnswersResult => {
  const correctMap = Object.fromEntries(
    correctPositions.map((p) => [p.idCharecter, p.position]),
  );

  const status: StatusErrorMap = {};

  let hasEmpty = false;
  let hasErrors = false;

  answers.forEach((item) => {
    const correct = correctMap[item.idCharecter];

    // пустое поле
    if (!item.input.trim()) {
      status[item.idCharecter] = "noSelect";
      hasEmpty = true;
      return;
    }

    // неверный формат
    if (!item.position) {
      status[item.idCharecter] = "false";
      hasErrors = true;
      return;
    }

    // неверная позиция
    if (
      !correct ||
      item.position.column !== correct.column ||
      item.position.roomId !== correct.roomId
    ) {
      status[item.idCharecter] = "false";
      hasErrors = true;
      return;
    }

    status[item.idCharecter] = "true";
  });

  return {
    status,
    hasEmpty,
    hasErrors,
    isSuccess: !hasEmpty && !hasErrors,
  };
};

export const parseCommand = (value: string): Position | null => {
  const match = value.match(/^([a-e])([1-4])$/);

  if (!match) return null;

  return {
  column: match[1] as ColumnName,
  roomId: Number(match[2]),
};
};
